import { render, staticRenderFns } from "./account.orders.vue?vue&type=template&id=1faf31b8&"
import script from "./account.orders.vue?vue&type=script&lang=js&"
export * from "./account.orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports